import React from 'react';

interface KeyMappingFieldProps {
  label: string;
  mappings: Record<string, string>;
  allKeys: string[];
  onMappingChange: (mappings: Record<string, string>) => void;
}

const KeyMappingField: React.FC<KeyMappingFieldProps> = ({
  label,
  mappings,
  allKeys,
  onMappingChange
}) => {
  const handleMappingChange = (key: string, value: string) => {
    const newMappings = { ...mappings, [key]: value };
    onMappingChange(newMappings);
  };

  return (
    <div className="mb-4">
      <div className="mb-2">
        <label className="text-sm font-medium text-gray-300">{label}</label>
      </div>
      <div className="space-y-2">
        {Object.entries(mappings).map(([key, value]) => (
          <div key={key} className="flex items-center space-x-2">
            <span className="text-sm text-gray-300 min-w-0 flex-1">{key}</span>
            <select
              value={value}
              onChange={(e) => handleMappingChange(key, e.target.value)}
              className="flex-1 px-2 py-1 bg-gray-700 border border-gray-600 rounded text-gray-300 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select a value</option>
              {allKeys.map(optionKey => (
                <option key={optionKey} value={optionKey}>
                  {optionKey}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyMappingField; 